import { render, staticRenderFns } from "./TypeVehicleDetail.vue?vue&type=template&id=c0de3b88&"
import script from "./TypeVehicleDetail.vue?vue&type=script&lang=js&"
export * from "./TypeVehicleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports